import { render, staticRenderFns } from "./PersonEnterContent.vue?vue&type=template&id=618858b6&scoped=true"
import script from "./PersonEnterContent.vue?vue&type=script&lang=js"
export * from "./PersonEnterContent.vue?vue&type=script&lang=js"
import style0 from "./PersonEnterContent.vue?vue&type=style&index=0&id=618858b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618858b6",
  null
  
)

export default component.exports